import type {PS} from '@wix/document-services-types'
import reordering from './reordering'

export default {
    isRTL(ps: PS, languageCode: string): boolean {
        return ps.extensionAPI.accessibility.languageDirection.isRTL(languageCode)
    },
    getSiteDirection(ps: PS): string {
        return ps.extensionAPI.accessibility.languageDirection.getSiteDirection()
    },
    setSiteDirection(ps: PS, siteDirection: string): void {
        ps.extensionAPI.accessibility.languageDirection.setSiteDirection(siteDirection)
    },
    async executeDomOrder(ps: PS): Promise<void> {
        const pageIds = ps.extensionAPI.page.getAllPagesIds(true)
        ps.extensionAPI.logger.interactionStarted('executeDomOrder', {
            extras: {
                pageIds
            }
        })

        await reordering.reorderComponents(ps, pageIds)

        ps.extensionAPI.logger.interactionEnded('executeDomOrder')
    }
}
